import { render } from "./CardBack.vue?vue&type=template&id=b261c798&scoped=true"
import script from "./CardBack.vue?vue&type=script&lang=js"
export * from "./CardBack.vue?vue&type=script&lang=js"

import "./CardBack.vue?vue&type=style&index=0&id=b261c798&lang=postcss&scoped=true"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b261c798"]])

export default __exports__